import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemRecordDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordDialogFC";
import {getUserInfoGameBaseAsync} from "@/app/userSliceAPI";
import {useAppDispatch} from "@/app/storeHooks";

export const RedeemKYCDialogFC: React.FC<SDialogProps> = (props) => {
    const { fcKey, onClose } = props;
    const { closeDialog } = useDialogMethods(fcKey);
    const dispatch = useAppDispatch();

    const onCloseDialog = () => {
        onClose?.();
        closeDialog();
    }

    const onClickYes = () => {
        onCloseDialog();

        SDialogManagerFC.closeDialogFC(RedeemRecordDialogFC);

        setTimeout(()=>{
            //直接去提现历史页面
            SDialogManagerFC.openDialog(RedeemRecordDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemRecordDialogFC),
                onClose: (isOk: boolean) => {
                    dispatch(getUserInfoGameBaseAsync());
                }
            })
        },2)

    }
    
    return (
        <SDialogFC
            {...props}
            onClose={onClose}
            title="CONFIRM VERIFICATION"
            buttons={[
                { label: "YES", onClick:  ()=>{onClickYes()}, style: "greenBtn" },
            ]}
        >
            <p>Please go to the withdrawal record page to check the verification result. If the verification fails, please initiate verification again.
            </p>
        </SDialogFC>
    );
};
